module.exports = __webpack_public_path__ + "img/teasers_8.c2ab2005.jpg";